import { useMutation } from "@tanstack/react-query";
import { privateApi } from "../../../api/api";
import { AssignResponse } from "../response/AssignResponse";
import { ValidationErrorResponse } from "../response/ValidationErrorResponse";
import { SyncPermissionsFormData } from "../schema/SyncPermissionsSchema";

interface useAssignPermissionsProps {
    roleId: number | undefined;
}

export const useAssignPermissions = ({ roleId }: useAssignPermissionsProps) => {
    return useMutation({
        mutationKey: ['role', 'assign', 'permissions', roleId],
        mutationFn: async (formData: SyncPermissionsFormData) => privateApi.post(`/v4/role/${roleId}/sync-permissions`, formData),
        onSuccess: async (response) => {
            try {
                console.log(response.data);

                const validationResult = AssignResponse.safeParse(response.data);

                if (!validationResult.success) {
                    console.error("Validation failed:", validationResult.error.errors);
                    throw new Error("Invalid assign permissions data format");
                }

                return validationResult.data
            } catch (error) {
                console.error('Failed to create assign permissions', error);
                throw error;
            }
        },
        onError: (error) => {
            const validationResult = ValidationErrorResponse.safeParse((error as any).response.data);

            if (!validationResult.success) {
                console.error("Validation failed:", validationResult.error.errors);
                throw new Error("Invalid assign permissions data format");
            } else {
                console.error(`Failed to assign permissions`, error);
                throw error;
            }
        }
    })
};